export { default as BringgIcon } from './bringg-icon/bringg-icon';

export { BringgFontIcons } from '../types/icon-types';
